import type { IconData } from '@stacksjs/iconify-core'

export const otherArrowsTransfer: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M15 3.5v3.75H0L7.25 0v3.5zm-14 9V8.75h15L8.75 16v-3.5z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default otherArrowsTransfer
